import { render, staticRenderFns } from "./tab2.vue?vue&type=template&id=23e76966&scoped=true&"
var script = {}
import style0 from "./tab2.vue?vue&type=style&index=0&id=23e76966&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e76966",
  null
  
)

export default component.exports